import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('qty_code'),
	fieldsMap.get('import_bulk_code'),
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;
